import { Link } from 'react-router-dom'

const EditorialSection = () => {
  return (
    <section
      className="relative w-full flex items-center justify-center overflow-hidden"
      style={{
        height: '484px',
        backgroundImage: "url('/Landing Page/Editorial/bg.png')",
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'scroll',
        margin: 0,
        padding: '80px 40px'
      }}
    >
      {/* Vignette Effect Overlay */}
      <div
        className="absolute inset-0 z-0"
        style={{
          background: 'radial-gradient(ellipse at center, transparent 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0.6) 100%)',
          pointerEvents: 'none'
        }}
      />
      <div className="text-center w-full max-w-4xl mx-auto flex flex-col items-center gap-8 z-10">
        {/* Editorial Title Image */}
        <div className="flex justify-center w-full">
          <img
            src="/Landing Page/Editorial/editorial_title.png"
            alt="Editorial"
            width={400}
            height={80}
            className="max-w-full h-auto w-auto max-w-[300px] sm:max-w-[350px] md:max-w-[400px]"
            style={{ transform: 'scale(1.2)' }}
          />
        </div>
        
        {/* Description Text */}
        <p
          className="mx-auto px-4 text-center text-white leading-relaxed"
          style={{
            fontFamily: 'Cardo, serif',
            fontSize: '16px',
            maxWidth: '572px'
          }}
        >
          Stay informed and inspired with what’s new,<br />
          noteworthy, and tailored for you.
        </p>
        
        {/* Subscribe Button */}
        <Link
          to="/editorial"
          className="inline-block font-medium transition-all duration-300 hover:shadow-lg text-center bg-white text-black px-6 py-2 sm:px-8 sm:py-3 md:px-9 md:py-3 text-sm sm:text-base"
          style={{
            textDecoration: 'none',
            border: 'none'
          }}
        >
          Subscribe to our Editorial
        </Link>
      </div>
    </section>
  )
}

export default EditorialSection